module.exports = __webpack_public_path__ + "img/ID.b50ea76c.svg";